<script setup>
const $props = defineProps({
  id: {
    type: [Number, String],
    required: true
  },
  name: {
    type: String,
    default: ''
  },
  closable: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: 'default'
  }
})
const $emits = defineEmits(['close'])

const onClose = () => {
  $emits('close', $props.id)
}
</script>

<template>
  <el-tag :closable="closable" :size="size" @close="onClose">
    {{ name || id }}
  </el-tag>
</template>
